// i18n area 'apps' — locale el-GR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.el-GR.meta.json.
import type { enUS } from './apps'

export const elGR: typeof enUS = {

  // Εφαρμογές, κύμα 1 (Annex R): διαχειριζόμενα κοντέινερ podman — υπό την εποπτεία
  // του worker σε έναν δηλωμένο κόμβο· εικόνα = lockfile branch@digest (Annex Q)
  // με πολιτική pinned/tracking· untagged προσάρτηση L3 με στατική IP.
  apps: {
    title: 'Εφαρμογές',
    create: 'Δημιουργία εφαρμογής',
    createTitle: 'Δημιουργία εφαρμογής',
    editTitle: 'Επεξεργασία εφαρμογής',
    name: 'Όνομα',
    nameHint: 'DNS-1123, μοναδικό μέσα στο scope — αμετάβλητο μετά τη δημιουργία.',
    node: 'Κόμβος',
    nodeHint: 'Ο κόμβος-μέλος που την εξυπηρετεί — ρητή τοποθέτηση (ο χρονοπρογραμματιστής έρχεται αργότερα).',
    image: 'Εικόνα',
    editImageHint: 'Μια νέα αναφορά επιλύεται εκ νέου μέσω του ευρετηρίου — η χειρονομία pin/rollback.',
    imagePolicy: 'Πολιτική',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Το digest μετακινείται μόνο κατόπιν εντολής.',
    policyTrackingHint: 'Αυτόματο rolling όταν μια ανανέωση μετακινεί το branch.',
    archMovePolicy: 'Μετακίνηση cross-arch',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Τι γίνεται αν η app μετακινηθεί σε node άλλης αρχιτεκτονικής: το refuse αρνείται τη μετακίνηση, το reresolve επαναυπολογίζει το lockfile από το branch στη νέα arch — το περιεχόμενο αλλάζει, και η απάντηση ονομάζει την αλλαγή του digest.',
    network: 'Δίκτυο',
    networkHint: 'Untagged προσάρτηση L3: ένα λογικό δίκτυο fabric (συνιστάται — πύλη/DNS από τη μοναδική του πηγή), μια επικάλυψη, ή μια γυμνή γέφυρα host (αποθαρρύνεται).',
    overlayPrefix: 'επικάλυψη:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'γέφυρα host:',
    ipAssignment: 'Εκχώρηση IP',
    ipStatic: 'Στατική',
    ipAuto: 'Αυτόματη (IPAM)',
    ipAssignmentHint_static: 'Τη διεύθυνση τη δίνετε εσείς, τώρα.',
    ipAssignmentHint_auto: 'Το IPAM επιλέγει μια ελεύθερη διεύθυνση από τα δεσμευμένα για το TVirt εύρη του δικτύου.',
    bridgeDiscouraged: 'Γυμνή γέφυρα host — ΑΠΟΘΑΡΡΥΝΕΤΑΙ: το TVirt δεν γνωρίζει τίποτα για τη διευθυνσιοδότησή της, οπότε πύλη και DNS πρέπει να δοθούν χειροκίνητα. Η συνιστώμενη οδός είναι ένα λογικό δίκτυο fabric.',
    ip: 'IP',
    ipHint: 'Στατική IPv4 μέσα στο υποδίκτυο της προσάρτησης.',
    ipCidrHint: 'Σε μορφή CIDR σε γυμνή γέφυρα (π.χ. 192.168.1.10/24) — δεν υπάρχει από πού να παραχθεί το πρόθεμα.',
    gateway: 'Πύλη',
    gatewayManualHint: 'Χειροκίνητα — μια γυμνή γέφυρα δεν παράγει τίποτα.',
    dnsServers: 'Διακομιστές DNS',
    dnsManualHint: 'Χειροκίνητα, χωρισμένοι με κόμμα — τουλάχιστον ένας.',
    rootKind: 'Root',
    rootEphemeral: 'εφήμερη',
    rootPersistent: 'μόνιμη',
    rootEphemeralHint: 'Αναδημιουργείται από την εικόνα σε κάθε αναδημιουργία· ζει στον εφήμερο χώρο αποθήκευσης της συστοιχίας.',
    rootEphemeralHintNamed: 'Αναδημιουργείται από την εικόνα σε κάθε αναδημιουργία· ζει στον εφήμερο χώρο αποθήκευσης της συστοιχίας ({name}).',
    rootPersistentHint: 'Επιβιώνει από τις επανεκκινήσεις· ζει στον χώρο αποθήκευσης που επιλέγετε.',
    rootStorage: 'Χώρος αποθήκευσης root',
    editRootStorageHint: 'Η root αποδίδεται εκ νέου στο νέο pool — τα υπάρχοντα δεδομένα ΔΕΝ μετακινούνται από μόνα τους.',
    volumes: 'Τόμοι',
    volumeAdd: 'Προσθήκη τόμου',
    volumeName: 'Όνομα',
    volumeMountPath: 'Διαδρομή mount',
    volumeKind: 'Τύπος',
    volumeStorage: 'Χώρος αποθήκευσης',
    devices: 'Συσκευές',
    deviceClassHint: 'Ζητείται μια ΚΛΑΣΗ (ένα tag gpu-device ή usb-device), ποτέ μια συγκεκριμένη συσκευή: ο δηλωμένος κόμβος πρέπει να έχει μία σημειωμένη για τις Apps. Πολλές Apps μπορούν να χρησιμοποιούν την ίδια συσκευή — ένα container τη μοιράζεται, δεν την αφαιρεί από τον host.',
    deviceSlot: 'Slot',
    deviceTag: 'Tag',
    deviceValue: 'Κλάση',
    deviceUnresolved: 'τώρα δεν επιλύεται τίποτα',
    noDeviceTags: 'Κανένα tag είδους gpu-device ή usb-device ακόμη: δημιούργησε ένα και ανάθεσέ το στις συσκευές που είναι σημειωμένες για τις Apps.',
    env: 'Περιβάλλον',
    envHint: 'Ένα ΚΛΕΙΔΙ=τιμή ανά γραμμή.',
    secretEnvTitle: 'Μυστικές μεταβλητές',
    secretEnvNotice: 'Μια μυστική τιμή δεν επιστρέφει ποτέ ξανά από το API: κανείς δεν τη διαβάζει πάλι, ούτε καν όποιος την έγραψε. Στο checkpoint ταξιδεύει σφραγισμένη με το masterpass, οπότε μια επαναφορά χωρίς το masterpass θα ζητήσει να ξαναγραφτεί.',
    secretEnvPromote: 'Κάντε μυστική μία από τις μεταβλητές που γράψατε παραπάνω:',
    secretEnvAdd: 'Προσθήκη μυστικής μεταβλητής',
    secretEnvName: 'Όνομα',
    secretEnvValue: 'Τιμή',
    secretEnvKept: 'διατηρείται — αφήστε το κενό για να μείνει ως έχει',
    secretEnvWithdrawWarning: 'Για να πάψει να αντιμετωπίζεται ως μυστική μια μεταβλητή που ήδη είναι, γράψτε της νέα τιμή: η άρση και μόνο του σημαδιού θα ήταν τρόπος να ΔΙΑΒΑΣΤΕΙ ό,τι δεν βγαίνει από το store. Η αφαίρεσή της, αντίθετα, τη σβήνει.',
    secretEnvChip: 'μυστικό',
    startNow: 'Άμεση εκκίνηση (διαφορετικά η εφαρμογή δημιουργείται σταματημένη)',
    deletePersistentIntro: 'Αυτή η εφαρμογή έχει μόνιμα δεδομένα — επιλέξτε τι θα γίνει με αυτά:',
    deleteKeepData: 'Διατήρηση των δεδομένων (οι φάκελοι μένουν στους χώρους αποθήκευσής τους, ορφανοί)',
    deletePurgeData: 'Διαγραφή και των δεδομένων',
    phase: 'Φάση',
    phase_running: 'Εκτελείται',
    phase_stopped: 'Σταματημένη',
    phase_error: 'Σφάλμα',
    phase_unknown: 'Άγνωστη',
    desiredState: 'Επιθυμητό',
    wantedRunning: 'σε εκτέλεση',
    wantedStopped: 'σταματημένη',
    start: 'Εκκίνηση',
    stop: 'Διακοπή',
    restart: 'Επανεκκίνηση',
    refreshImage: 'Ανανέωση εικόνας (υιοθέτηση του νέου @current)',
    logs: 'Καταγραφή',
    logsTitle: 'Καταγραφή',
    logsEmpty: 'Δεν καταγράφηκε καμία έξοδος.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Η App δεν εκτελείται — ένα shell χρειάζεται ζωντανό container. Τα logs της διαβάζονται σε οποιαδήποτε κατάσταση.',
    shellConnect: 'Σύνδεση',
    shellDisconnect: 'Αποσύνδεση',
    shellExited: 'Η συνεδρία τερματίστηκε με κωδικό εξόδου {code}.',
    shellEndedWithoutStatus: 'Η συνεδρία τερματίστηκε χωρίς κατάσταση εξόδου: {reason}',
    shellRevoked: 'Το ticket της συνεδρίας δεν είναι πλέον έγκυρο — έληξε, ή η σύνδεση που το άνοιξε ανακλήθηκε.',
    shellHint: 'Κάνε κλικ στο μαύρο πλαίσιο και πληκτρολόγησε: τα πλήκτρα φτάνουν στο container. Το Ctrl+C και τα βέλη λειτουργούν· το exit κλείνει το shell.',
    shellStatus: {
      connecting: 'Σύνδεση…',
      connected: 'Συνδεδεμένη',
      ended: 'Τερματίστηκε'
    },
    deleteRunningError: 'Η {name} είναι επιθυμητή σε εκτέλεση — διακόψτε την πρώτα.',

    // Τυπικό παράθυρο διαλόγου (round #156): οι καρτέλες λεπτομερειών και τα πεδία
    // του contract που έλειπαν — κάθε πεδίο της Εφαρμογής ορατό, κλειδαριές με το γιατί τους.
    tabs: {
      general: 'Γενικά',
      image: 'Εικόνα',
      network: 'Δίκτυο',
      storage: 'Αποθήκευση',
      devices: 'Συσκευές',
      observed: 'Παρατηρούμενα'
    },
    attachment: 'Προσάρτηση',
    runningDigest: 'Digest σε εκτέλεση',
    lastError: 'Τελευταίο σφάλμα',
    reportObservedAt: 'Τελευταία αναφορά του worker',
    desiredStateLock: 'Το διέπουν οι ενέργειες Εκκίνηση/Διακοπή — ποτέ άμεση επεξεργασία.',
    ipEditDisabledHint: 'Επεξεργάσιμο μόνο με στατική εκχώρηση.',
    derivedFromNetworkHint: 'Παράγεται από τη μοναδική πηγή του δικτύου — χειροκίνητα μόνο σε γυμνή γέφυρα με στατική IP.',
    ephemeralUnset: 'μη διαμορφωμένος',
    ephemeralMissing: 'Ο εφήμερος χώρος αποθήκευσης των Εφαρμογών δεν έχει διαμορφωθεί — η δημιουργία εφαρμογής με εφήμερα μέρη (root ή τόμους) απορρίπτεται μέχρι να τον ορίσετε.',
    ephemeralCurrent: 'Εφήμερος χώρος αποθήκευσης των Εφαρμογών: {name}',
    ephemeralMissingCreate: 'Αυτή η εφαρμογή έχει εφήμερα μέρη, αλλά ο εφήμερος χώρος αποθήκευσης των Εφαρμογών δεν έχει οριστεί — η δημιουργία θα απορριφθεί. Ορίστε τον πρώτα από το banner της σελίδας Εφαρμογές.',
    setEphemeral: 'Ορισμός εφήμερου χώρου αποθήκευσης',
    changeEphemeral: 'Αλλαγή εφήμερου χώρου αποθήκευσης',
    setEphemeralTitle: 'Ορισμός του εφήμερου χώρου αποθήκευσης των Εφαρμογών',
    changeEphemeralTitle: 'Αλλαγή του εφήμερου χώρου αποθήκευσης των Εφαρμογών',
    ephemeralStorageHint: 'ΠΡΟΕΠΙΛΟΓΗ σε επίπεδο συστοιχίας: το dir-like pool όπου ζουν οι εφήμερες root και οι εφήμεροι τόμοι κάθε εφαρμογής, εκτός αν η εφαρμογή δηλώνει δικό της override. Μια αλλαγή δεν γίνεται εν θερμώ και δεν επανεκκινεί τίποτα: ισχύει από την επόμενη εκκίνηση κάθε εφαρμογής — τα εφήμερα δεδομένα δεν μετακινούνται.',
    ephemeralPool: 'Pool αποθήκευσης',
    ephemeralOverride: 'Εφήμερος χώρος αποθήκευσης (override ανά εφαρμογή)',
    ephemeralOverrideInherit: 'Κληρονόμηση της προεπιλογής της συστοιχίας',
    ephemeralOverrideInheritNamed: 'Κληρονόμηση της προεπιλογής της συστοιχίας ({name})',
    ephemeralOverrideHint: 'Pool ανά εφαρμογή για την εφήμερη root και τους εφήμερους τόμους — αφήστε το κενό για να κληρονομηθεί η προεπιλογή της συστοιχίας. Η αλλαγή του δεν γίνεται εν θερμώ και δεν επανεκκινεί τίποτα: ισχύει από την επόμενη εκκίνηση (τα εφήμερα δεδομένα ξαναγεννιούνται κενά στο νέο pool) και απαιτεί το δικαίωμα app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Όλα τα branch',
    imageBranchHint: 'Περιορίζει τις εικόνες σε όσες ονομάζει αυτό το branch· χωρίς branch φαίνονται όλες οι εικόνες του repository.',
    imageDigestHint: 'Το περιεχόμενο: επιλέγεται από τον πίνακα των digest, που φέρει την προέλευση και την αρχιτεκτονική του. Το ίδιο branch προσφέρει ένα ανά αρχιτεκτονική, και δεν είναι εναλλάξιμα.',
    imageLockfile: 'Επιλυμένη αναφορά',
    imageNoImages: 'Καμία εικόνα στην cache για αυτό το repository — κατέβασε μία από τις Εικόνες OCI.',
    imageHeadNotCached: 'δεν είναι στην cache — λήψη κατά την εκκίνηση',
    imageNoRegistries: 'Κανένα repository καταχωρισμένο: καταχώρισε ένα για να μπορείς να επιλέξεις εικόνα.',
    imageChosenHint: 'Η εικόνα επιλέγεται από τον καταρράκτη στο παράθυρο επεξεργασίας: η αναφορά δεν πληκτρολογείται ποτέ.',
    registerRepositoryHint: 'Η καταχώριση δεν κατεβάζει τίποτα: κάνει ένα repository παρακολουθήσιμο, ώστε η εικόνα να επιλέγεται χωρίς έξοδο από αυτό το παράθυρο.',
    registerRepositoryBranchHint: 'Προαιρετικό: το πρώτο branch προς παρακολούθηση (π.χ. latest).',
    registerRepositoryElsewhere: 'Το repository που ψάχνεις δεν είναι καταχωρισμένο: η καταχώριση γίνεται στην ενότητα Εικόνες OCI, από όποιον έχει το δικαίωμα.'
  },

  // Πρότυπα CT (round K2 #63): τα ΥΛΟΠΟΙΗΜΕΝΑ αντικείμενα CT — η εισαγωγή από
  // κατάλογο είναι η μόνη είσοδος· τα αρχεία μεταφορτώνονται μέσα στους καταλόγους.
  cts: {
    createAction: 'Δημιουργία CT',
    createTitle: 'Δημιουργία κοντέινερ από πρότυπο',
    createError: 'Το κοντέινερ δεν δημιουργήθηκε',
    template: 'Πρότυπο CT',
    noTemplates: 'Κανένα πρότυπο CT — εισαγάγετε ένα από τα Πρότυπα CT',
    resources: 'Πόροι',
    node: 'Κόμβος',
    phase: {
      defined: 'Δεν ενεργοποιήθηκε ποτέ',
      materializing: 'Υλοποιείται',
      ready: 'Έτοιμο',
      starting: 'Εκκινείται',
      running: 'Εκτελείται',
      stopping: 'Διακόπτεται',
      stopped: 'Σταματημένο',
      deleting: 'Διαγράφεται',
      error: 'Σε σφάλμα'
    },
    actions: {
      start: 'Εκκίνηση',
      stop: 'Διακοπή',
      restart: 'Επανεκκίνηση',
      markTemplate: 'Προαγωγή σε πρότυπο CT',
      error: 'Η ενέργεια απορρίφθηκε'
    },
    markTemplate: {
      confirmTitle: 'Προαγωγή του «{name}» σε πρότυπο CT;',
      confirmBody: 'Το κοντέινερ φεύγει από αυτήν τη λίστα και περνά στα Πρότυπα CT, αμέσως έτοιμο να γεννήσει νέα CT. Τα μεταδεδομένα του παραμένουν επεξεργάσιμα, και μπορείτε να το επαναφέρετε σε CT ανά πάσα στιγμή.',
      confirm: 'Προαγωγή',
      moved: 'Το «{name}» είναι πλέον πρότυπο CT — θα το βρείτε στα Πρότυπα CT.'
    },
    stopCause: {
      api: 'Σταματημένο μέσω του TVirt',
      'ct-exit': 'Το κοντέινερ τερματίστηκε από μόνο του',
      'host-reboot': 'Πέθανε με την επανεκκίνηση του κόμβου',
      'start-failed': 'Η εκκίνηση απέτυχε — το σφάλμα της εργασίας λέει τι λείπει και πώς διορθώνεται'
    },

    console: 'Κονσόλα',
    consoleUnavailable: 'Το κοντέινερ δεν εκτελείται — μια κονσόλα χρειάζεται ζωντανό κοντέινερ. Οι καταγραφές του, αντίθετα, διαβάζονται σε οποιαδήποτε κατάσταση.',
    consoleNoTemplate: 'Ένα πρότυπο δεν τρέχει ποτέ, οπότε δεν έχει κονσόλα: δημιουργήστε από αυτό ένα CT και ανοίξτε τη δική του.',
    consoleConnect: 'Σύνδεση',
    consoleDisconnect: 'Αποσύνδεση',
    consoleReconnect: 'Επανασύνδεση',
    consoleTakenBy: 'Άλλος χειριστής κατέλαβε αυτήν την κονσόλα ({user}). Μία κονσόλα ανά κοντέινερ: η επανασύνδεση σας την ξαναδίνει.',
    consoleHint: 'Κάντε κλικ στο μαύρο πλαίσιο και γράψτε: τα πλήκτρα φτάνουν στο κοντέινερ. Το Ctrl+C και τα βέλη λειτουργούν.',
    consoleEndpointDown: 'Το σημείο πρόσβασης της κονσόλας δεν ανοίγει στον κόμβο που εξυπηρετεί το container: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Το container δεν εκτελείται — ένα shell χρειάζεται ζωντανό container. Τα logs του διαβάζονται σε οποιαδήποτε κατάσταση.',
    shellNoTemplate: 'Ένα template δεν τρέχει ποτέ, άρα δεν έχει shell: δημιούργησε ένα CT από αυτό και άνοιξε το δικό του.',
    shellConnect: 'Σύνδεση',
    shellDisconnect: 'Αποσύνδεση',
    shellExited: 'Η συνεδρία τερματίστηκε με κωδικό εξόδου {code}.',
    shellEndedWithoutStatus: 'Η συνεδρία τερματίστηκε χωρίς κατάσταση εξόδου: {reason}',
    shellRevoked: 'Το ticket της συνεδρίας δεν είναι πλέον έγκυρο — έληξε, ή η σύνδεση που το άνοιξε ανακλήθηκε.',
    shellHint: 'Κάνε κλικ στο μαύρο πλαίσιο και πληκτρολόγησε: τα πλήκτρα φτάνουν στο container. Το Ctrl+C και τα βέλη λειτουργούν· το exit κλείνει το shell.',
    shellStatus: {
      connecting: 'Σύνδεση…',
      connected: 'Συνδεδεμένη',
      ended: 'Τερματίστηκε'
    },
    rootPassword: 'Κωδικός root',
    rootPasswordHint: 'Γράφεται μία φορά στο αντιγραμμένο rootfs (ως hash, δεν εμφανίζεται ξανά). Οι εικόνες των διανομών δεν έχουν κωδικό root: χωρίς αυτόν, το shell είναι η μόνη είσοδος.',
    sshKeys: 'Δημόσια κλειδιά SSH του root',
    sshKeysHint: 'Ένα δημόσιο κλειδί OpenSSH ανά γραμμή, στο root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Σύνδεση…',
      connected: 'Συνδεδεμένη',
      reconnecting: 'Επανασύνδεση…'
    },
    logs: 'Καταγραφή',
    logsTitle: 'Καταγραφή',
    logsEmpty: 'Δεν καταγράφηκε καμία έξοδος.',
    logsSource: 'Ποια καταγραφή',
    logsSourceConsole: 'Η κονσόλα του init του κοντέινερ — γιατί δεν ξεκίνησε η υπηρεσία μέσα',
    logsSourceSupervisor: 'Ο επόπτης liblxc — γιατί το κοντέινερ δεν έφτασε ποτέ να τρέξει',
    logsNeverStarted: 'Δεν ξεκίνησε ποτέ, οπότε δεν υπάρχει ακόμη τίποτα καταγεγραμμένο — ξεκινήστε το, και οι καταγραφές θα υπάρχουν ακόμη κι αν η εκκίνηση αποτύχει.',
    logsNoTemplate: 'Ένα πρότυπο δεν τρέχει ποτέ, οπότε δεν κατέγραψε ποτέ τίποτα.',
    logsError: 'Δεν ήταν δυνατή η λήψη της καταγραφής',

    // Τυπικό παράθυρο διαλόγου (round #156): οι καρτέλες λεπτομερειών που μοιράζονται
    // οι λίστες CT και Πρότυπα CT, συν οι κλειδαριές με το γιατί τους.
    tabs: {
      general: 'Γενικά',
      hardware: 'Υλικό',
      network: 'Δίκτυο',
      provenance: 'Προέλευση'
    },
    templateFlag: 'Πρότυπο CT',
    templateLock: 'Αλλάζει μόνο με τις ενέργειες Προαγωγή / Επαναφορά σε CT — ποτέ άμεση επεξεργασία.',
    sourceLock: 'Προέλευση, καταχωρημένη κατά τη γέννηση — δεν ξαναγράφεται ποτέ· μια νεκρή πηγή αφήνει τη γυμνή αναφορά.',
    storageLock: 'Καθορίζεται στη δημιουργία — η μετακίνηση του rootfs είναι μελλοντικό round.',
    startedAt: 'Εκκινήθηκε',
    lastStop: 'Τελευταία διακοπή',
    editNicsTitle: 'Επεξεργασία δικτύων',
    nicDisconnected: 'αποσυνδεδεμένη'
  },
  ctTemplates: {
    title: 'Πρότυπα CT',
    importAction: 'Εισαγωγή από κατάλογο',
    importTitle: 'Εισαγωγή προτύπου CT από τον κατάλογο',
    importSubmit: 'Εισαγωγή',
    importError: 'Η εισαγωγή απορρίφθηκε',
    importHint: 'Η υλοποίηση αντιγράφει το rootfs στον επιλεγμένο χώρο αποθήκευσης — το αρχείο του καταλόγου μένει ανέπαφο. Για να προσθέσετε νέα αρχεία, μεταφορτώστε τα πρώτα μέσα σε έναν κατάλογο.',
    sourceFile: 'Αρχείο προτύπου CT',
    sourceFileHint: 'Τα αρχεία ct-rootfs του επιλεγμένου καταλόγου, μόνο τα έτοιμα',
    noFiles: 'Κανένα έτοιμο αρχείο ct-rootfs σε αυτόν τον κατάλογο — μεταφορτώστε ένα από τη σελίδα του καταλόγου',
    source: 'Αρχείο προέλευσης',
    rootfsStorage: 'Χώρος αποθήκευσης του rootfs',
    rootfsStorageHint: "Όπου ζει το εξαγμένο δέντρο rootfs — ένας χώρος αποθήκευσης με σύστημα αρχείων και αρκετό ελεύθερο χώρο για το εξαγμένο μέγεθος συν περίπου 1 GiB περιθώριο (αλλιώς η εισαγωγή αποτυγχάνει).",
    resources: 'Πόροι',
    cores: 'vCPU',
    memoryMiB: 'Μνήμη (MiB)',
    cpuLimit: 'Όριο CPU',
    cpuLimitHint: 'Ισοδύναμα πυρήνων host (π.χ. 1.5)· κενό = χωρίς ανώτατο όριο',
    cpuUncapped: 'χωρίς ανώτατο όριο',
    cpuWeight: 'Βάρος CPU',
    hostname: 'Hostname',
    hostnameHint: 'Κενό = το όνομα του CT',
    nameservers: 'Διακομιστές ονομάτων DNS',
    dnsHint: 'Χωρισμένοι με κόμμα· κενό = κληρονομούνται από τον host',
    searchDomains: 'Τομείς αναζήτησης DNS',
    dnsInherited: 'Κληρονομήθηκε από τον host',
    networks: 'Δίκτυα',
    nicSlot: 'Υποδοχή NIC',
    phase: {
      materializing: 'Υλοποιείται',
      ready: 'Έτοιμο',
      deleting: 'Διαγράφεται',
      error: 'Σφάλμα'
    },
    exportAction: 'Εξαγωγή στον κατάλογο',
    exportTitle: 'Εξαγωγή στον κατάλογο',
    exportSubmit: 'Εξαγωγή',
    exportError: 'Η εξαγωγή απορρίφθηκε',
    exportHint: 'Πακετάρει το υλοποιημένο rootfs σε ένα ΝΕΟ αρχείο ct-rootfs στον επιλεγμένο κατάλογο — το πρότυπο μένει ανέπαφο.',
    exportName: 'Όνομα αρχείου',
    exportNameHint: 'Κενό = <template>-export-<n>',
    markCt: {
      action: 'Επαναφορά σε CT',
      confirmTitle: 'Επαναφορά του «{name}» σε CT;',
      confirmBody: 'Το πρότυπο φεύγει από αυτήν τη λίστα και επιστρέφει στη λίστα CT, ξανά εκκινήσιμο. Μέχρι να το προαγάγετε ξανά, δεν μπορούν να δημιουργηθούν CT από αυτό.',
      confirm: 'Επαναφορά σε CT',
      moved: 'Το «{name}» είναι ξανά ένα απλό CT — θα το βρείτε στη λίστα CT.'
    }
  },

  // OCI, κύμα 1 (Annex Q — το μοντέλο tag-ως-branch): ένα tag OCI είναι ένα branch
  // (κινητός δείκτης), το digest είναι το commit· ανανέωση = «git fetch»,
  // pull = επίλυσε ΤΩΡΑ, κατέβασε ΕΚΕΙΝΟ το digest.
  oci: {
    registriesTitle: 'Μητρώα OCI',
    imagesTitle: 'Εικόνες OCI',
    provider: 'Πάροχος',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Γενικός',
    providerImmutableHint: 'Ο πάροχος είναι αμετάβλητος μετά τη δημιουργία — ένας διαφορετικός πάροχος είναι ένα νέο μητρώο.',
    url: 'URL',
    urlHintPreset: 'Προσυμπληρωμένο από τον πάροχο — παρακάμψτε το μόνο για mirror.',
    urlHintRequired: 'Υποχρεωτικό για τα γενικά μητρώα: το βασικό URL https://.',
    urlHintEcr: 'Υποχρεωτικό: τα endpoint ECR είναι ανά λογαριασμό/ανά περιοχή — δεν υπάρχει προσυμπληρωμένη τιμή.',
    credential: 'Διαπιστευτήριο',
    credentialNone: 'Ανώνυμη πρόσβαση',
    credentialHint: 'Μια καταχώρηση της αποθήκης κλειδιών με όνομα χρήστη και κωδικό πρόσβασης· οι worker την επιλύουν τη στιγμή της χρήσης — ποτέ αρχεία auth ανά κόμβο.',
    nameHint: 'Όνομα σαν host (docker.io, registry.intra)· μοναδικό ανά scope, αμετάβλητο',
    addRegistry: 'Προσθήκη μητρώου',
    addRegistryTitle: 'Προσθήκη μητρώου OCI',
    verify: 'Επαλήθευση',
    verifyState: 'Επαλήθευση',
    verified: 'Επαληθεύτηκε',
    verifyFailed: 'Απέτυχε',
    neverVerified: 'Δεν επαληθεύτηκε ποτέ',
    registryInUseError: 'Το «{name}» έχει ακόμη καταχωρημένα αποθετήρια — διαγράψτε τα πρώτα.',
    repositories: 'Αποθετήρια',
    repositoriesHint: 'Η καταχώρηση παρακολουθεί τα branch (tags OCI) — δεν κατεβάζει τίποτα. Η ανανέωση επιλύει κάθε παρακολουθούμενο branch και κρατά το reflog.',
    noRepositories: 'Κανένα αποθετήριο καταχωρημένο σε αυτό το μητρώο.',
    registerRepository: 'Καταχώρηση αποθετηρίου',
    repoPath: 'Διαδρομή',
    repoPathHint: 'Διαδρομή του αποθετηρίου στο μητρώο, π.χ. «example» ή «library/nginx»',
    branches: 'Branch',
    branchesHint: 'Παρακολουθούμενα branch (tags OCI), χωρισμένα με κόμμα — π.χ. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Επιλύεται ΤΩΡΑ: το pull κατεβάζει το digest στο οποίο δείχνει το branch σήμερα.',
    refresh: 'Ανανέωση',
    deleteRepository: 'Διαγραφή αποθετηρίου',
    reflogCount: '{n} προηγούμενες',
    noResolutions: 'Δεν ανανεώθηκε ποτέ — καμία επίλυση δεν έχει παρατηρηθεί.',
    refreshFailed: 'Η τελευταία ανανέωση απέτυχε ({when})',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των αποθετηρίων.',
    reference: 'Αναφορά',
    digest: 'Digest',
    digestHint: 'sha256:… — η ακριβής εικόνα, χωρίς branch (αποσπασμένη)',
    size: 'Μέγεθος',
    nodes: 'Κόμβοι',
    detached: 'αποσπασμένη',
    detachedHint: 'Κατέβηκε με digest, χωρίς branch — ο έλεγχος απόκλισης δεν εφαρμόζεται.',
    pulledAt: 'Κατέβηκε',
    pull: 'Pull',
    pullTitle: 'Pull εικόνας',
    pullHint: 'Pre-warming, ποτέ προαπαιτούμενο: ένα pull κατά branch επιλύει ΤΩΡΑ και κατεβάζει ΕΚΕΙΝΟ το digest· ένα pull κατά digest είναι αποσπασμένο.',
    pullError: 'Το pull απορρίφθηκε',
    pullMode: 'Pull κατά',
    pullModeBranch: 'Branch (επίλυση τώρα)',
    pullModeDigest: 'Digest (αποσπασμένο)',
    pullModeBranchHint: 'Η ειλικρινής προεπιλογή: όπως το apt install, αν εκτελεστεί ξανά αργότερα μπορεί να δώσει διαφορετική εικόνα.',
    pullModeDigestHint: 'Ακριβές digest — αναπαραγωγιμότητα και rollback· παραιτείται από τον έλεγχο απόκλισης.',

    // Το μοτίβο των δύο κουμπιών (#88, επικύρωση 2026-07-30 βράδυ): «από μητρώο»
    // είναι το υπάρχον καθοδηγούμενο pull, «από κατάλογο» υλοποιεί μια έτοιμη
    // αρχειοθήκη oci-image (η οδός air-gapped).
    importFromRegistry: 'Εισαγωγή από μητρώο',
    importFromCatalog: 'Εισαγωγή από κατάλογο',
    importCatalogTitle: 'Εισαγωγή εικόνας OCI από κατάλογο',
    importCatalogHint: 'Η οδός air-gapped: μια έτοιμη αρχειοθήκη oci-image (tar/tar.gz — docker-archive ή oci-archive) υλοποιείται στην αποθήκη εικόνων με την αναφορά catalog/<catalogo>/<file>@<digest>· οι εφαρμογές την καταναλώνουν όπως κάθε άλλη εικόνα. Οι αρχειοθήκες μεταφορτώνονται στους καταλόγους — αυτή η ενότητα μόνο εισάγει.',
    importCatalogFile: 'Αρχειοθήκη',
    importCatalogFileHint: 'Τα έτοιμα αρχεία oci-image του επιλεγμένου καταλόγου.',
    importCatalogNoFiles: 'Καμία έτοιμη αρχειοθήκη oci-image σε αυτόν τον κατάλογο — μεταφορτώστε μία από τις λεπτομέρειες του καταλόγου.',
    importCatalogError: 'Η εισαγωγή απορρίφθηκε',
    registry: 'Μητρώο',
    repository: 'Αποθετήριο',
    cacheMissing: 'Η cache OCI της συστοιχίας δεν έχει διαμορφωθεί — τα pull απορρίπτονται μέχρι να ορίσετε ένα pool αποθήκευσης.',
    setCache: 'Ορισμός cache',
    setCacheTitle: 'Διαμόρφωση της cache OCI',
    setCacheHint: 'Το ΠΡΟΕΠΙΛΕΓΜΕΝΟ pool σε επίπεδο συστοιχίας που φιλοξενεί τα blob των κατεβασμένων εικόνων — ένα scope μπορεί να κάνει override με δικό του pool (σελίδα Scope). Η αλλαγή του δεν γίνεται εν θερμώ και δεν επανεκκινεί τίποτα, ούτε μετακινεί τα blob: επανεμφανίζονται lazy στην επόμενη εκκίνηση/χρήση.',
    cachePool: 'Pool αποθήκευσης',
    changeCache: 'Αλλαγή cache',
    changeCacheTitle: 'Αλλαγή του pool της cache OCI',
    cacheCurrent: 'Cache OCI της συστοιχίας (προεπιλογή): {name}',
    sectionOverview: 'Επισκόπηση',
    sectionRepositories: 'Αποθετήρια',
    sectionExplore: 'Εξερεύνηση',
    exploreHint: 'Ζωντανή απομακρυσμένη αναζήτηση στο μητρώο — πλήρης στο Docker Hub (περιγραφή, λήψεις, αστέρια), στους άλλους παρόχους best-effort. Επιλέξτε ένα αποτέλεσμα για να διαβάσετε την πλήρη περιγραφή του και να ξεφυλλίσετε τα απομακρυσμένα tags του· από ένα tag μπορείτε να προσθέσετε την αναφορά σε ένα αποθετήριο TVirt.',
    exploreSearch: 'Αναζήτηση',
    exploreUnsupported: 'Αυτός ο πάροχος δεν υποστηρίζει αναζήτηση.',
    exploreNoResult: 'Κανένα αποθετήριο δεν ταιριάζει.',
    exploreNoTags: 'Κανένα tag δεν ταιριάζει σε αυτό το αποθετήριο.',
    exploreOfficial: 'Επίσημο',
    explorePulls: 'Λήψεις',
    exploreStars: 'Αστέρια',
    exploreUpdated: 'Ενημερώθηκε {when}',
    exploreLoadMore: 'Φόρτωση περισσότερων',
    exploreSelectHint: 'Επιλέξτε ένα αποτέλεσμα: η πλήρης περιγραφή και τα απομακρυσμένα tags φορτώνονται εδώ.',
    exploreNoDescription: 'Καμία περιγραφή διαθέσιμη από αυτόν τον πάροχο.',
    exploreTagsTitle: 'Απομακρυσμένα tags',
    exploreTagFilter: 'Αναζήτηση tags',
    exploreAddToRepo: 'Προσθήκη σε αποθετήριο',
    exploreAdded: 'Το {path}:{tag} παρακολουθείται πλέον — δείτε την ενότητα Αποθετήρια.',
    addBranch: 'Προσθήκη branch',
    purgeRequiredTitle: 'Διαγραφή του «{name}» και των εικόνων του;',
    purgeRequiredBody: 'Καμία εφαρμογή δεν καταναλώνει αυτό το αποθετήριο, αλλά υπάρχουν ακόμη κατεβασμένες εικόνες: η διαγραφή του αφαιρεί και τις εγγραφές τους, και τα blob στην cache περνούν στον garbage collector.',
    purgeConfirm: 'Διαγραφή και των εικόνων',
    providerSelectHint: 'Επιλέξτε τον τύπο του μητρώου: η κάρτα εξηγεί την προσυμπλήρωση και τη χρήση.',
    providerDesc: {
      dockerhub: 'Το δημόσιο μητρώο Docker: προσυμπληρωμένο URL, πλήρης αναζήτηση με περιγραφές και μετρήσεις.',
      ghcr: 'GitHub Container Registry: προσυμπληρωμένο URL· οι λογαριασμοί χρησιμοποιούν personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpoint ανά λογαριασμό/ανά περιοχή — το URL πρέπει να δοθεί.',
      quay: 'Το μητρώο Red Hat Quay: προσυμπληρωμένο URL.',
      generic: 'Self-hosted μητρώο (Harbor, registry:2, …): το URL https:// είναι υποχρεωτικό.'
    },

    // Τυπικό παράθυρο διαλόγου (round #156): τα πεδία λεπτομερειών εικόνας/μητρώου
    // που οι στήλες δεν έδειχναν.
    layerCount: 'Layer',
    verifiedAt: 'Τελευταία επαλήθευση',
    verifyOk: 'Έκβαση',
    verifyMessage: 'Μήνυμα επαλήθευσης',

    // Το μοντέλο #348/R39: η εικόνα ΕΙΝΑΙ το digest — το περιεχόμενο — και registry, repository και branch είναι τα ΟΝΟΜΑΤΑ που το φτάνουν.
    head: 'Head',
    heads: 'Κεφαλές ανά αρχιτεκτονική',
    listDigest: 'Digest της λίστας',
    neverResolved: 'Δεν επιλύθηκε ποτέ',
    totalSize: 'Συνολικό μέγεθος',
    reflogTitle: 'Ιστορικό επιλύσεων',
    usedBy: 'Χρησιμοποιείται από',
    usageLockfile: 'lockfile',
    usageRunning: 'σε εκτέλεση',
    evictable: 'εκτοπίσιμο',
    evict: 'Εκτόπιση από την cache',
    evictHeadTitle: 'Εκτόπιση του {digest};',
    evictHeadBody: 'Είναι η τρέχουσα επίλυση τουλάχιστον ενός συλλέκτη: η εκτόπισή του είναι θεμιτή — είναι μόνο cache, το απομακρυσμένο branch το σερβίρει ακόμη — αλλά δεν πρέπει ποτέ να συμβεί κατά λάθος. Το blob είναι ΕΝΑ: η εκτόπιση αδειάζει όλους τους συλλέκτες που το μοιράζονται.',
    evictConfirm: 'Εκτόπιση ούτως ή άλλως',

    arch: 'Αρχιτεκτονική',
    names: 'Ονόματα',
    noNames: 'χωρίς όνομα',
    views: 'Προβολές',
    lastView: 'τελευταία προβολή',
    evictLastViewTitle: 'Αφαίρεση της τελευταίας αναφοράς στο {digest};',
    evictLastViewBody: 'Είναι η τελευταία προβολή αυτού του περιεχομένου: αφαιρώντας την, η εικόνα παύει να υπάρχει στο TVirt και τα byte ({size}) ελευθερώνονται. Είναι το docker image rm του μοντέλου — όχι παρενέργεια, αλλά η ίδια η ενέργεια.',
    branchesTabHint: 'Τα παρακολουθούμενα branch αυτού του repository: για καθένα οι σημερινές κεφαλές — μία ανά αρχιτεκτονική — το χρονικό των ανανεώσεων και πόσες από τις εικόνες που ονόμασε βρίσκονται στην cache. Η ανανέωση είναι το «git fetch» του repository: επιλύει όλα τα branch του μονομιάς.',
    noBranches: 'Κανένα branch δεν παρακολουθείται σε αυτό το repository.',
    stopObserving: 'Διακοπή παρακολούθησης του branch',
    pullBranch: 'Λήψη στην cache της κεφαλής του branch (το refresh επιλύει, αυτό κατεβάζει)',
    pullDigest: 'Λήψη στην cache αυτού του digest',
    imageCount: 'Εικόνες',
    deleteBranchPurgeTitle: 'Να μείνουν χωρίς όνομα οι εικόνες του {name};',
    deleteBranchPurgeBody: 'Καμία εφαρμογή δεν ονομάζει αυτό το branch, όμως ορισμένες εικόνες φτάνονται μόνο μέσω αυτού: διαγράφοντάς το μένουν στην cache χωρίς όνομα, καταγεγραμμένες στις εικόνες του repository και αφαιρέσιμες με το χέρι.',
    deleteBranchPurgeConfirm: 'Διαγραφή και εικόνες χωρίς όνομα',
    imagesTabHint: 'Οι εικόνες αυτού του repository — τα περιεχόμενα, δηλαδή τα digest — ορατές και χωρίς επιλογή branch. Μια εικόνα είναι μοναδική ανά συστάδα: τα ονόματα που τη φτάνουν μπορεί να είναι περισσότερα από ένα.',
    noImages: 'Καμία εικόνα αυτού του repository δεν είναι υλοποιημένη στην cache.',
    deleteRepositoryTitle: 'Διαγραφή του {name};',
    deleteRepositoryBody: 'Το repository και τα branch του χάνονται μαζί με το χρονικό τους. Οι εικόνες μένουν στην cache: χάνουν μόνο αυτό το όνομα. Repository που ονομάζει μια εφαρμογή δεν διαγράφεται.',
    provenanceCatalog: 'κατάλογος',
    refreshedAt: 'Ανανεώθηκε',
    neverRefreshed: 'Ποτέ δεν ανανεώθηκε',
    sectionBranches: 'Branch',
    sectionImages: 'Εικόνες',
    repositoriesGovernedElsewhere: 'Εδώ τα repository απλώς φαίνονται: η καταχώρισή τους, η ανανέωση, η παρακολούθηση των branch και η αφαίρεση των εικόνων γίνονται στην ενότητα Εικόνες OCI.',
    gotoImages: 'Μετάβαση στις Εικόνες OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pods',
    containers: 'Κοντέινερ',
    instances: 'Στιγμιότυπα',
    instancesTooltip: '{running} σε εκτέλεση, {error} σε σφάλμα',
    placement: 'Τοποθέτηση',
    spread: 'διασπορά',
    ha: 'HA',
    templateRevision: 'αναθεώρηση',
    deleting: 'Διαγράφεται',
    empty: 'Κανένα pod — δημιουργήστε μια εφαρμογή (ένα κοντέινερ) ή ένα pod από το CLI (create-pod).',
    openInstances: 'Άνοιγμα στιγμιοτύπων',
    rollingRestart: 'Κυλιόμενη επανεκκίνηση',
    scale: 'Κλιμάκωση',
    scaleTitle: 'Κλιμάκωση {name}',
    scaleHint: 'Πλήθος στιγμιοτύπων (0–64): προς τα πάνω γεννιέται ο χαμηλότερος ελεύθερος αριθμός, προς τα κάτω αποσύρεται ο υψηλότερος και τα μόνιμα δεδομένα του μένουν.',
    scaleError: 'Η κλιμάκωση απέτυχε',
    replicas: 'Αντίγραφα',
    deleteRunningError: 'Το {name} εκτελείται — σταματήστε το πρώτα.',
    deleteInstancesIntro: 'Και τα {count} στιγμιότυπα θα αφαιρεθούν.',
    stateRunning: 'Σε εκτέλεση',
    stateStopped: 'Σταματημένο',
    editor: {
      createTitle: 'Δημιουργία Pod',
      create: 'Δημιουργία Pod',
      editTitle: 'Επεξεργασία Pod',
      nameHint: 'DNS-1123, το πολύ 58 χαρακτήρες — τα στιγμιότυπα ονομάζονται <όνομα>-<δείκτης>· αμετάβλητο μετά τη δημιουργία.',
      restartPolicy: 'Πολιτική επανεκκίνησης',
      restartPolicyHint_always: 'Ο κόμβος επανεκκινεί κάθε τερματισμένο container, με εκθετική αναμονή (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Επανεκκινείται μόνο container που τερμάτισε με μη μηδενικό κωδικό· η έξοδος 0 μένει σε ηρεμία.',
      restartPolicyHint_never: 'Ένα τερματισμένο container μένει ως έχει — το στιγμιότυπο καταλήγει succeeded ή failed.',
      grace: 'Χάρη (s)',
      graceHint: 'Το όριο SIGTERM → SIGKILL μιας διακοπής.',
      hostname: 'Όνομα κεντρικού υπολογιστή',
      hostnameHint: 'Κενό = το όνομα του στιγμιοτύπου.',
      hostnameDefault: 'το όνομα του στιγμιοτύπου',
      sharePid: 'Κοινός χώρος ονομάτων PID μεταξύ των containers',
      containersIntro: 'Τα init containers εκτελούνται μέχρι τέλους, με τη σειρά, πριν ξεκινήσουν τα containers· τα containers μοιράζονται το δίκτυο του στιγμιοτύπου (μία IP, localhost μεταξύ τους).',
      initContainers: 'Init containers',
      initAdd: 'Προσθήκη init container',
      initHint: 'Καθένα πρέπει να τερματίσει με 0· μια αποτυχία θέτει το στιγμιότυπο σε σφάλμα και ο κόμβος το ξαναδοκιμάζει με αναμονή.',
      containerAdd: 'Προσθήκη container',
      atLeastOne: 'Ένα Pod χρειάζεται τουλάχιστον ένα container.',
      duplicateNames: 'Τα ονόματα των containers πρέπει να είναι μοναδικά στο Pod (μαζί με τα init containers).',
      containerName: 'Όνομα container',
      containerInvalid: 'Αυτό το container είναι ελλιπές: όνομα (DNS-1123), εικόνα, προσαρτήσεις σε δηλωμένους τόμους, αριθμητικά όρια και έλεγχος.',
      command: 'Εντολή',
      commandHint: 'Αντικαθιστά το entrypoint της εικόνας — ένα όρισμα ανά γραμμή, ποτέ συμβολοσειρά κελύφους.',
      args: 'Ορίσματα',
      argsHint: 'Ένα ανά γραμμή (το CMD της εικόνας αν είναι κενό).',
      mounts: 'Προσαρτήσεις',
      mountAdd: 'Προσθήκη προσάρτησης',
      mountNoVolumes: 'Δηλώστε πρώτα έναν τόμο στην καρτέλα Αποθήκευση.',
      readOnly: 'μόνο ανάγνωση',
      resources: 'Όρια',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (π.χ. 1.5)',
      memory: 'Μνήμη (MiB)',
      memoryHint: 'podman --memory',
      health: 'Έλεγχος ζωτικότητας',
      healthCmd: 'Εντολή ελέγχου',
      healthCmdHint: 'Εκτελείται μέσα στο container από τον κόμβο σε κάθε κύκλο εποπτείας — ένα όρισμα ανά γραμμή· έξοδος 0 = υγιές.',
      healthTimeout: 'Χρονικό όριο (s)',
      healthRetries: 'Επαναλήψεις',
      healthRetriesHint: 'Διαδοχικές αποτυχίες πριν ο κόμβος επανεκκινήσει το container.',
      ips: 'Στατικές διευθύνσεις',
      ipsHint: 'Μία ανά στιγμιότυπο, με σειρά τακτικού αριθμού — κλιμάκωση πέρα από τη λίστα απορρίπτεται.',
      instance: 'στιγμιότυπο',
      volumesHint: 'Οι τόμοι ανήκουν στο Pod· η διαδρομή προσάρτησης σε κάθε container (καρτέλα Containers).',
      spread: 'Κατανομή',
      spreadHint_preferred: 'Στιγμιότυπα σε διαφορετικούς κόμβους όταν είναι δυνατόν.',
      spreadHint_required: 'Στιγμιότυπα σε διαφορετικούς κόμβους, αλλιώς η κλιμάκωση απορρίπτεται.',
      spreadHint_none: 'Μόνο ο αποφασίζων.',
      ha: 'Υψηλή διαθεσιμότητα (opt-in)',
      haHint: 'Κάθε μόνιμο κομμάτι σε κοινόχρηστο storage· αν ο κόμβος πεθάνει, ο HA decider αναδημιουργεί τις περιπτώσεις σε άλλο μέλος (αυτόματο failover, όπως οι HA VM).',
      yes: 'ναι',
      no: 'όχι'
    },
    detail: {
      container: 'Container',
      actions: 'Ενέργειες',
      ready: 'Έτοιμο',
      notReady: 'Μη έτοιμο',
      restarts: 'Επανεκκινήσεις',
      lastRestartAt: 'Τελευταία επανεκκίνηση:',
      backoffUntil: 'Νέα δοκιμή στις',
      stateAbsent: 'απόν',
      stateRunning: 'εκτελείται',
      stateTerminated: 'τερματισμένο',
      stateWaiting: 'σε αναμονή',
      init: 'init',
      noInstances: 'Κανένα στιγμιότυπο (αντίγραφα 0).',
      ha: 'HA',
      haHint: 'Αυτόματο failover: αν ο κόμβος πεθάνει, ο HA decider αναδημιουργεί την περίπτωση σε άλλο μέλος (κάθε μόνιμο κομμάτι σε κοινόχρηστο storage).',
      authority: 'Authority (κόμβος)',
      homeless: 'χωρίς authority',
      homelessHint: 'Η επαναφορά από checkpoint αφήνει έξω την authority (#380): κανένας κόμβος δεν την εξυπηρετεί μέχρι να κλιμακώσετε το Pod (ακόμη και στον ίδιο αριθμό αντιγράφων).',
      restartContainer: 'Επανεκκίνηση μόνο αυτού του container (το pod παραμένει ενεργό)',
      divergingHint: 'Η επιθυμητή κατάσταση αυτού του στιγμιοτύπου διαφέρει από την προεπιλογή του Pod (PD-P19).',
      revisionLag: 'αναθεώρηση {applied} εφαρμοσμένη από {current}',
      updatedInstances: '{updated}/{desired} στιγμιότυπα σε αυτή την αναθεώρηση'
    }
  }
}
